import PaginationStyles from "styles/Pagination.module.css";
import Link from "next/link";
import ChevronLeft from "./svg/ChevronLeft";
import ChevronRight from "./svg/ChevronRight";
import { useRouter } from "next/router";

export default function Pagination(props) {
	const router = useRouter();
	let currentRoute = router.asPath;

	const { totalPages, currentPage } = props;
	//remove /page/...
	currentRoute = currentRoute.split("/page")[0];

	const nextDisabled = parseInt(currentPage, 10) === parseInt(totalPages, 10); //10
	const prevDisabled = parseInt(currentPage, 10) === 1; //10

	const prevPageUrl =
		currentPage === "2" ? `${currentRoute}` : `${currentRoute}/page/${parseInt(currentPage, 10) - 1}`;

	const nextPageUrl = `${currentRoute}/page/${parseInt(currentPage, 10) + 1}`;

	return (
		<div className={PaginationStyles.pagination}>
			<ol className={PaginationStyles.pagination__list}>
				<li className={PaginationStyles.pagination__listItem}>
					{!prevDisabled && (
						<Link href={prevPageUrl}>
							<span className={PaginationStyles.pagination__chevronContainer__left}>
								<ChevronLeft />
							</span>
							<span>Previous page</span>
						</Link>
					)}
				</li>
				<li
					className={`${PaginationStyles.pagination__listItem} ${PaginationStyles.pagination__listItem__pageDescriptor}`}
				>
					Page {currentPage} of {totalPages}
				</li>
				<li className={PaginationStyles.pagination__listItem}>
					{!nextDisabled && (
						<Link href={nextPageUrl}>
							<span>Next page</span>
							<span className={PaginationStyles.pagination__chevronContainer__right}>
								<ChevronRight />
							</span>
						</Link>
					)}
				</li>
			</ol>
		</div>
	);
}
